module.exports = __webpack_public_path__ + "img/g-f_bg.2e8c3fe6.png";